import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api, type Organization } from './api';

export interface OrgLookup {
  byId: Map<string, Organization>;
  resolveName: (orgId: string | undefined | null) => string;
  loading: boolean;
}

export function useOrgLookup(): OrgLookup {
  const { data, isLoading } = useQuery({
    queryKey: ['organizations'],
    queryFn: () => api.listOrganizations(),
    staleTime: 5 * 60 * 1000,
  });

  return useMemo<OrgLookup>(() => {
    const byId = new Map<string, Organization>();
    for (const o of data?.items ?? []) {
      if (o.id) byId.set(o.id, o);
    }
    return {
      byId,
      resolveName: (orgId) => {
        if (!orgId) return '—';
        const org = byId.get(orgId);
        if (!org) return orgId;
        return org.name ?? org.company ?? orgId;
      },
      loading: isLoading,
    };
  }, [data, isLoading]);
}
